<template>
  <transition name="fade-bottom">
    <div class="messenger" :style=stylePositon v-if="showMessenger">
      <a href="javascript:" class="m-close" @click="cancel">Ⅹ</a>
      <div class="leaveUs">
        <p>{{ $t('messenger.Q01') }}</p>
        <div class="clearfix">
          <span class="st">{{ $t('messenger.Q02') }}<i>*</i></span>
          <div class="sc">
            <textarea name="" id="" cols="30" rows="10" v-model="content"></textarea>
          </div>
        </div>
        <div class="clearfix">
          <span class="st">{{ $t('messenger.Q03') }}<i>*</i></span>
          <div class="sc"><input type="text" v-model="username"></div>
        </div>
        <div class="clearfix">
          <span class="st">{{ $t('messenger.Q04') }}</span>
          <div class="sc"><input type="text" v-model="companyName"></div>
        </div>
        <div class="clearfix">
          <span class="st">{{ $t('messenger.Q05') }}</span>
          <div class="sc"><input type="text" v-model="adress"></div>
        </div>
        <div class="clearfix">
          <span class="st">{{ $t('messenger.Q06') }}<i class="i-font">*</i></span>
          <div class="sc"><input type="text" v-model="mobile" maxlength="11"></div>
        </div>

        <div class="clearfix" style="padding-top:10px;text-align:center;">
          <a href="javascript:" class="ss-btn" @click="save">{{ $t('messenger.Q07') }}</a>
        </div>


      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Messenger',
  data() {
    return {
      content: '',
      username: '',
      companyName: '',
      adress: '',
      mobile: '',
      stylePositon: {}
    }
  },
  props: ['showMessenger'],
  watch: {
    '$route': function() {
      if(this.$route.path == "/index") {
        this.stylePositon = {
          bottom: '38px',
          right: '85px'
        }
      } else {
        this.stylePositon = {
          bottom: '85px',
          right: '70px'
        }
      }
    }
  },
  methods: {
    cancel: function() {
      this.$emit('toMessenger', '5')
    },
    async save() {
      var asc = document.querySelectorAll('.sc')
      for(var i = 0; i < asc.length; i++) {
        asc[i].classList.remove('err')
      }
      if(this.content.length == 0) {
        this.$alert(this.$t('Q08'))
        asc[0].classList.add('err')
        return
      } else if(this.content.length > 255) {
        this.$alert(this.$t('Q09'))
        asc[0].classList.add('err')
        return
      } else if(this.username == '') {
        this.$alert(this.$t('Q10'))
        asc[1].classList.add('err')
        return
      } else if(this.mobile == '') {
        this.$alert(this.$t('Q11'))
        return
      } else if(this.mobile.length < 7) {                       // 座机 和 手机 只判断 位数
        asc[4].classList.add('err')
        this.$alert(this.$t('Q12'))
        return
      }
      // else if(!(this.$utils.checkPhone(this.mobile) || this.checkGuhua(this.mobile)) ){
      //     asc[4].classList.add('err');
      //     this.dialog('联系电话格式不正确')
      //     return ;
      // }
      // else if(!this.checkGuhua(this.mobile)){
      //         asc[4].classList.add('err');
      //         this.dialog('联系电话格式不正确')
      //         return ;
      // }
      let res = await this.$services.addConsultingUser({
        userName: this.username,
        mobile: this.mobile,
        content: this.content,
        companyName: this.companyName,
        companyAddress: this.adress
      })
      if(res.code == 0) {
        this.$alert(this.$t('m95'))
        this.content = ''
        this.username = ''
        this.companyName = ''
        this.adress = ''
        this.mobile = ''
        this.cancel()
      } else {
        this.$alert(res.message)
      }
    },
    checkGuhua(val) {
      var reg = /([0-9]{3,4}-)?[0-9]{7,8}/
      return reg.test(val)
    }
  },
}
</script>

<style lang="scss" scoped>
.messenger {
  width: 420px;
  padding: 20px 20px 40px;
  border: 1px solid #eee;
  position: fixed !important;
  background: #fff;
  z-index: 100;
  bottom: 10px;
  right: 60px;

  &::before {
    position: absolute;
    content: "";
    height: 0;
    width: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid #eee;
    right: -6px;
    bottom: 10px;
    margin-top: -6px;
  }

  .m-close {
    position: absolute;
    top: -12px;
    right: -12px;
    background: #fff;
    color: #000;
    text-align: center;
    line-height: 30px;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    transform: scale(1);
    transition: all .3s cubic-bezier(.4, 0, .2, 1);
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.6);
  }

  .m-close:hover {
    transform: scale(1.12);
    opacity: 0.9;
    transition: all .3s cubic-bezier(.4, 0, .2, 1);
  }
}

.leaveUs {
  display: inline-block;

  p {
    line-height: 32px;
  }

  .clearfix {
    margin: 12px auto;
  }

  .st, .sc {
    float: left;
  }

  .st {
    width: 20%;
    text-align: right;
    margin-right: 4%;
    line-height: 30px;
  }

  .sc {
    width: 75%;
    text-align: left;
    border: 1px solid #ccc;
  }

  textarea, input {
    display: block;
    width: 100%;
    height: 100%;
    border: none;
    text-indent: 1em;
  }

  input[type="text"] {
    line-height: 30px;
    height: 30px;
  }

  // .s-btn{margin:30px auto;line-height: 36px;border-radius: 5px;background:linear-gradient(90deg,#1e97c9,#4d5ec6);color:#fff;cursor: pointer;text-align:center;width:30%;}
  .ss-btn {
    text-align: center;
    display: inline-block;
    border-radius: 5px;
    line-height: 30px;
    height: 30px;
    width: 70px;
    text-align: center;
    color: #fff;
    background: #1e97c9;
    background: linear-gradient(90deg, #1e97c9, #4d5ec6);
  }

  .err {
    border: 1px solid red;
    box-shadow: 0 0 3px rgba(201, 0, 0, 0.6) inset;
    transition: all ease .5s;
  }
}

.fade-bottom-enter-active, .fade-bottom-leave-active {
  transition: all .3s;
}

.fade-bottom-enter, .fade-bottom-leave-to {
  opacity: 0;
  transform: translateY(100%);
}
</style>




// WEBPACK FOOTER //
// src/pages/Messenger.vue